import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";

export interface PaginationMeta {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

export interface DoctorServerFilters {
    head_quarter_id?: number;
    location_id?: number;
    city?: string;
    search?: string;
}

export const getAlldoctors = async (
    tenant_id: number,
    page: number = 1,
    per_page: number = 15,
    filters?: DoctorServerFilters
): Promise<{ data: any[]; pagination: PaginationMeta }> => {
    const response = await api.get(`${API_ROUTES.DOCTOR}/list/${tenant_id}`, {
        params: { page, per_page, ...filters },
    });
    return {
        data: response.data.data,
        pagination: response.data.pagination,
    };
}

export const addNewDoctor = async (data: any) => {
    const response = await api.post(
        API_ROUTES.DOCTOR,
        data
    );
    return response;
};

export const deleteDoctor = async (doctorID: number) => {
    const response = await api.delete(`${API_ROUTES.DOCTOR}/${doctorID}`);
    return response;
}

export const editDoctor = async (doctorID: number, edits: any) => {
    const response = await api.put(`${API_ROUTES.DOCTOR}/${doctorID}`, edits)
    return response;
}

export const getAllDoctorCategories = async (tenantId: number) => {
    const response = await api.get(`${API_ROUTES.DOCTOR_CATEGORY}/list/${tenantId}`)
    return response.data.data;
}

export const createNewDoctorCategory = async (tenantId: number, name: string) => {
    const data = {
        tenant_id: tenantId,
        name: name
    }
    const response = await api.post(API_ROUTES.DOCTOR_CATEGORY, data)
    return response;
}

export const deleteDoctorCategory = async (categoryId: number) => {
    const response = await api.delete(`${API_ROUTES.DOCTOR_CATEGORY}/${categoryId}`)
    return response;
}

export const editDoctorCategory = async (categoryId: number, tenantId: number, name: string) => {
    const data = {
        tenant_id: tenantId,
        name: name
    }

    const response = await api.put(`${API_ROUTES.DOCTOR_CATEGORY}/${categoryId}`, data);
    return response;
}

export const getAllDoctorSpecialization = async (tenantId: number) => {
    const response = await api.get(`${API_ROUTES.SPECIALIZATION}/list/${tenantId}`);
    return response.data.data;
}

export const createNewDoctorSpecialization = async (tenantId: number, name: string) => {
    const data = {
        tenant_id: tenantId,
        name: name
    }

    const response = await api.post(API_ROUTES.SPECIALIZATION, data);
    return response;
}

export const deleteDoctorSpecialization = async (specializationId: number) => {
    const response = await api.delete(`${API_ROUTES.SPECIALIZATION}/${specializationId}`);
    return response;

}

export const editDoctorSpecialization = async (specializationId: number, tenantId: number, name: string) => {
    const data = {
        "tenant_id": tenantId,
        "name": name,
    }
    const response = await api.put(`${API_ROUTES.SPECIALIZATION}/${specializationId}`, data);
    return response;
}
